<template>
  <v-container class="py-2 px-0">
    <div v-for="event in events">
      <div v-if="category === 'logs'">
        <Log
          :date="event.date"
          :category="event.category"
          :level="event.level"
          :event="event.event"
          :message="event.message"
        ></Log>
      </div>
      <div v-if="category === 'warnings'">
        <Warning
          :date="getDate(event.date)"
          :description="event.description"
          :level="event.data.level"
          :reason="event.data.reason"
          :task="event.data.task"
          :hidden="event.data.hidden"
        ></Warning>
      </div>
      <div v-if="category === 'feedbacks'">
        <MeetingFeedback
          :date="getDate(event.date)"
          :description="event.description"
          :level="event.data.level"
          :message="event.data.message"
          :mark="event.data.mark"
        ></MeetingFeedback>
      </div>
      <div v-if="category === 'reviews' && event.eventName === 'reviewForReviewer'">
        <ReviewForReviewer
          :date="getDate(event.date)"
          :description="event.description"
          :examinee="getUserInfo(event.data.examineeId)"
          :examineeLevel="event.data.examineeLevel"
          :homeworks="event.data.homeworks"
          :marks="event.data.marks"
          :feedbackFromExaminee="event.data.feedbackFromExaminee"
          :feedbackFromReviewer="event.data.feedbackFromReviewer"
          :durationFromExaminee="event.data.durationFromExaminee"
          :durationFromReviewer="event.data.durationFromReviewer"
          :bestReviewer="event.data.bestReviewer"
          :deleted="event.deleted"
        ></ReviewForReviewer>
      </div>
      <div v-if="category === 'reviews' && event.eventName === 'reviewForExaminee'">
        <ReviewForExaminee
          :date="getDate(event.date)"
          :description="event.description"
          :reviewer="getUserInfo(event.data.reviewerId)"
          :reviewerLevel="event.data.reviewerLevel"
          :homeworks="event.data.homeworks"
          :marks="event.data.marks"
          :feedbackFromExaminee="event.data.feedbackFromExaminee"
          :feedbackFromReviewer="event.data.feedbackFromReviewer"
          :durationFromExaminee="event.data.durationFromExaminee"
          :durationFromReviewer="event.data.durationFromReviewer"
          :deleted="event.deleted"
        ></ReviewForExaminee>
      </div>
      <div v-if="category === 'bestReviewer'">
        <BestReviewer
          :examinee="getUserInfo(event.data.examineeId)"
        ></BestReviewer>
      </div>
      <div v-if="category === 'inflatedMarks'">
        <InflatedMark
          :examinee="getUserInfo(event.examineeId)"
          :level="event.level"
          :task="event.task"
        ></InflatedMark>
      </div>
    </div>
    <div v-if="category === 'vacation'">
      <VacationAccept></VacationAccept>
    </div>
    <div v-if="category === 'drop'">
      <DropProgress
        :date="data.date"
        :message="data.info"
      ></DropProgress>
    </div>
  </v-container>
</template>

<script>
  import Log from "./events/Log";
  import NewLevel from "./events/OpenLevel";
  import MoveLevel from "./events/MoveLevel";
  import DropProgress from "./events/DropProgress";
  import VacationAccept from "./events/VacationAccept";
  import VacationDecline from "./events/VacationDecline";
  import HomeworkUpload from "./events/HomeworkUpload";
  import Warning from "./events/Warning";
  import MeetingFeedback from "./events/MeetingFeedback";
  import ReviewAvailability from "./events/ReviewAvailability";
  import ReviewConfirm from "./events/ReviewConfirm";
  import ReviewDecline from "./events/ReviewDecline";
  import ChangeReviewerRequest from "./events/ChangeReviewerRequest";
  import ReviewForReviewer from "./events/ReviewForReviewer";
  import ReviewForExaminee from "./events/ReviewForExaminee";
  import BestReviewer from "@/components/events/BestReviewer";
  import InflatedMark from "@/components/events/InflatedMark";

  export default {
    name: "Events",
    components: {
      InflatedMark,
      BestReviewer,
      Log,
      ReviewForExaminee,
      ReviewForReviewer,
      ChangeReviewerRequest,
      ReviewDecline,
      ReviewConfirm,
      ReviewAvailability,
      MeetingFeedback,
      Warning,
      HomeworkUpload,
      VacationDecline,
      VacationAccept,
      DropProgress,
      MoveLevel,
      NewLevel
    },
    props: ["events", "category", "data"],
    methods: {
      getDate: function(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB")
          // + ' '
          // + date.toLocaleTimeString("en-GB", {hour: '2-digit', minute:'2-digit'});
      },

      getUserInfo(userId) {
        return this.$store.state.users[userId];
      }
    }
  }
</script>

<style scoped>

</style>
